// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__oZxMe","backButton":"Button_backButton__3w2_j"};